import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Facet, FacetOption, FilterService } from '@lobos/library';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';

@UntilDestroy()
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-facet-item]',
  templateUrl: './facet-item.component.html',
  styleUrls: ['./facet-item.component.scss'],
  // TODO refactore to hostbinding
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { '[class.open]': 'open' },
})
export class FacetItemComponent implements OnInit {
  /** facet (filter) */
  @Input() facet!: Facet;
  @Input() openIfActive = true;

  /** accordeon state */
  open = false;

  /** searchInput used for binding to the input */
  searchInput = new UntypedFormControl('');

  /** observable of the debounced search value */
  filterValue$: Observable<string> | undefined;

  @Output() facetChanged = new EventEmitter<FacetOption>();

  constructor(private filterService: FilterService, private ref: ChangeDetectorRef) {}

  ngOnInit() {
    setTimeout(() => {
      if (this.openIfActive) {
        const open = !!this.facet.values.find((option: FacetOption) => option.isActive);

        if (open !== this.open) {
          this.open = open;
          this.ref.markForCheck();
        }
      }
    }, 750);

    this.filterValue$ = this.searchInput.valueChanges.pipe(startWith(''), untilDestroyed(this), debounceTime(300), distinctUntilChanged());
  }

  /** toggles the accordeon state */
  toggleAccordion() {
    this.open = !this.open;
  }

  /** used to track ngFor loop of options */
  trackByFn(_: number, item: Facet) {
    return item.key;
  }

  /** resets the searchInput to an empty string */
  resetSearchInput() {
    this.searchInput.setValue('');
  }

  clearAllFilters() {
    this.filterService.getFilters().forEach((filter) => {
      filter.name === this.facet.key ? this.filterService.removeFilterWithParam(filter.value, filter.name) : null;
    });
  }
}
